'use strict'

const React = require('react')
module.exports = React.addons.CSSTransitionGroup



// WEBPACK FOOTER //
// ./infra/reactCssTransitionGroup-shim.js